import { useQueryClient } from '@tanstack/react-query';
import type { components } from '../generated/v1';
import { $api } from './api';
import { invalidateProductQueries } from './productsNew';

export type OrderTag = components['schemas']['OrderTag'];

function invalidateOrderQueries(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries({ queryKey: ['get', '/sale_orders'] });
  queryClient.invalidateQueries({ queryKey: ['get', '/sale_orders/{sale_order_id}'] });
}

function invalidate(queryClient: ReturnType<typeof useQueryClient>) {
  invalidateProductQueries(queryClient);
}

export const useTagsQuery = (search: string) => {
  return $api.useQuery('get', '/tags', {
    params: {
      query: { search, limit: 20 },
    },
  });
};

export const useTagCreate = () => {
  const queryClient = useQueryClient();
  return $api.useMutation('post', '/tags', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/tags'] });
    },
  });
};

export const useTagDelete = () => {
  const queryClient = useQueryClient();
  return $api.useMutation('delete', '/tags/{tag_id}', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/tags'] });
      invalidateOrderQueries(queryClient);
    },
  });
};

export const useSetOrderTags = () => {
  const queryClient = useQueryClient();
  return $api.useMutation('put', '/sale_orders/{sale_order_id}/tags', {
    onSuccess() {
      invalidateOrderQueries(queryClient);
    },
  });
};

export const useProductTagAdd = () => {
  const queryClient = useQueryClient();

  return $api.useMutation('post', '/products/{product_id}/tags/{tag_id}', {
    onSuccess() {
      invalidate(queryClient);
    },
  });
};

export const useProductTagRemove = () => {
  const queryClient = useQueryClient();

  const removeProductTagMutation = $api.useMutation('delete', '/products/{product_id}/tags/{tag_id}', {
    onSuccess() {
      invalidate(queryClient);
    },
  });

  return removeProductTagMutation;
};
